import Currency from 'components/Currency/Currency';
import CustomLink from 'components/TableLink';
import React, { useMemo, useState } from 'react';
import { DATE_FORMATS, formatAddress, formatDate, getPageLimit } from 'utils';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';
import { Modal } from 'react-bootstrap';

const OrderTableModal = (props) => {
  const { toggleModal, data } = props;

  const handleClose = () => {
    toggleModal();
  };

  const columns = useMemo(() => [
    {
      name: 'OrderID',
      selector: 'objectId',
      sortable: false,
      width: '120px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/orders/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: false,
      width: '120px',
    },
    {
      name: 'Delivery Method',
      selector: 'selectedDeliveryMethod',
      format: (row) => {
        return row.selectedDeliveryMethod === 'ROUTABLE' ? row.preferredDeliveryDay : row.selectedDeliveryMethod;
      },
      sortable: false,
      width: '170px',
    },
    {
      name: 'Ordered At',
      selector: 'createdAt',
      sortable: false,
      format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
      width: '170px',
    },
    {
      name: 'Total',
      selector: 'total',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => <Currency amount={row.total / 100} default="-" />,
      width: '120px',
    },
    {
      name: 'Cost',
      selector: 'cost',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => <Currency amount={row.cost} default="-" />,
      width: '120px',
    },
    {
      name: 'Waiting For Payment',
      selector: 'waitingForPayment',
      format: (row) => row.waitingForPayment?.toString() ?? '-',
    },
    {
      name: 'Refunded Amount',
      selector: 'refundedAmount',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => row.refundedAmount ? (<Currency amount={row.refundedAmount} />) : '-',
      width: '120px',
    },
    {
      name: 'Purchaser Info',
      selector: 'purchaser',
      sortable: false,
      width: '250px',
      // eslint-disable-next-line react/display-name
      cell: (row) => <div style={{ height: 'auto' }}>
        <div style={{ fontSize: '16px' }}>{(row.purchaser.full_name ? row.purchaser.full_name : row.purchaser.username)}</div>
        <div style={{ fontSize: '12px', color: '#8F8F8F' }}>{formatAddress(row.addressObject)}</div>
      </div>,
    },
    {
      name: 'Account Info',
      selector: 'purchaser.account',
      width: '180px',
      // eslint-disable-next-line react/display-name
      cell: (row) => row.purchaser?.account ? (
        <div style={{ height: 'auto' }}>
          <div style={{ fontSize: '12px', color: '#8F8F8F' }}>{row.purchaser.account.objectId}</div>
          <div style={{ fontSize: '16px' }}>{(row.purchaser.full_name || row.purchaser.account.name || '')}</div>
        </div>
      ) : '-',
    },
    {
      name: 'Notes',
      selector: 'notes',
      sortable: false,
      format: row => row.notes + row.notes + row.notes + row.notes + row.notes + row.notes + row.notes,
      width: '220px',
      // eslint-disable-next-line react/display-name
      cell: (row) => <div style={{ height: 'auto' }} onClick={() => window.location.assign(`/orders/${row.objectId}`)}>
        {row.notes ? row.notes : '-'}
      </div>,
    },
    {
      name: 'Route ID',
      selector: 'route',
      sortable: false,
      width: '175px',
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div data-for={'route-detail'} data-tip={''}>
            {row.route?.objectId || row.route?.id || '-'}
          </div>
        </>
      ),
    },
  ], []);

  return (
    <Modal show={true} animation={false} size='lg' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Orders</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: '100%' }}>
          <DataTable
            keyField="objectId"
            columns={columns}
            noHeader={true}
            data={data}
            highlightOnHover={true}
            customStyles={tableStyles}
            pagination={true}
            paginationPerPage={8}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OrderTableModal;